function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';

// import './styles.css';
import DiViewerMenu from "./components/di-viewer-menu";
// import DiViewerMenuEdit from "./components/di-viewer-menu-edit";
import DiViewer from "./components/di-viewer";
// import DiMakeupEngine from "./components/di-makeup-engine";
import Engine from './components/di-makeup-engine/engine.js';
import calibration from "./components/di-calibration/index.js";
import { modes, validateSkus } from './utils';
import Loader from './components/loader/loader';

var DiLiveTryOn = function (_Component) {
    _inherits(DiLiveTryOn, _Component);

    function DiLiveTryOn(props) {
        _classCallCheck(this, DiLiveTryOn);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        var auxCalibration = calibration();
        var lookObjEmpty = { look: '', withSoftFocus: auxCalibration.softFocus };

        _this.state = {
            webLTOeventName: 'di-web-lto',
            calibration: auxCalibration,
            lookObjEmpty: lookObjEmpty,
            lookObj: lookObjEmpty,
            skuMap: new Map(),
            // mode: props.mode ? props.mode : modes.videoShowing, // sets initial mode
            visibleMode: props.mode ? props.mode : modes.videoShowing,
            visibleModeList: [modes.videoShowing, modes.canvasShowing, modes.photoCanvasShowing, modes.modelCanvasShowing],
            showingModeList: [modes.canvasShowing, modes.photoCanvasShowing, modes.modelCanvasShowing],
            // playVideo: typeof props.startEngine == "boolean" ? props.startEngine : true,
            resolution: props.resolution ? props.resolution : "vga",
            menuHeight: 0,
            // dimensionRatio: props.ratio ? props.ratio : .75,
            // configs: ['configs.json'],
            loaderImage: "/innovation/glamlab/public/images/loader" + (Math.floor(Math.random() * 2) + 1) + ".jpg",
            selectedCategory: ''
        };

        if (props.modeObj && props.modeObj.value) {
            if (props.modeObj.value == 'liveVideo') {
                _this.state.mode = modes.canvasShowing;
                _this.state.videoSrc = '';
                _this.state.playingRecordedVideo = false;
                _this.state.playVideo = true;
            } else if (props.modeObj.value == 'recordedVideo') {
                _this.state.mode = modes.canvasShowing;
                _this.state.videoSrc = props.modeObj.url;
                _this.state.playingRecordedVideo = true;
                _this.state.playVideo = false;
            } else {
                _this.state.mode = props.modeObj.value;
            }
        }

        _this.callbackFromComponent = _this.callbackFromComponent.bind(_this);
        _this.skusAreEqual = _this.skusAreEqual.bind(_this);
        _this.getSkuInfoAndSetLook = _this.getSkuInfoAndSetLook.bind(_this);
        _this.setLook = _this.setLook.bind(_this);
        _this.snap = _this.snap.bind(_this);
        _this.afterApply = _this.afterApply.bind(_this);
        _this.sendToParentComponent = _this.sendToParentComponent.bind(_this);
        _this.startStopEngine = _this.startStopEngine.bind(_this);
        _this.changeMode = _this.changeMode.bind(_this);
        return _this;
    }

    DiLiveTryOn.prototype.componentDidMount = function componentDidMount() {
        var _this2 = this;

        document.addEventListener(this.state.webLTOeventName, function (data) {
            if (data.detail.skus) {
                _this2.getSkuInfoAndSetLook(data.detail.skus);
            }
            if (_this2.state.engineReady) {
                if (typeof data.detail.startEngine == 'number') {
                    _this2.startStopEngine(data.detail.startEngine);
                }
                if (data.detail.modeObj) {
                    _this2.changeMode(data.detail.modeObj);
                }
            }
        });

        if (this.props.skus) {
            this.getSkuInfoAndSetLook(this.props.skus);
        }

        this.sendToParentComponent(this.state);
    };

    DiLiveTryOn.prototype.afterApply = function afterApply(lookObj, canvas, modeToSet, mode, url) {
        var nextState = {};
        var callbackObj = {};
        if (this.state.mode != mode) {
            nextState.mode = mode;
            callbackObj.mode = mode;
        }
        if (modeToSet && nextState.mode != modeToSet) {
            nextState.mode = modeToSet;
            callbackObj.mode = modeToSet;
        }
        if (this.state.visibleModeList.indexOf(nextState.mode) >= 0 && this.state.visibleMode != nextState.mode) {
            // set visible mode
            nextState.visibleMode = nextState.mode;
        }
        if (lookObj && (this.state.lookObj.look != lookObj.look || this.state.lookObj.withSoftFocus != lookObj.withSoftFocus)) {
            nextState.lookObj = lookObj;
        }
        if (!this.state.canvas || canvas.width != this.state.canvas.width || canvas.height != this.state.canvas.height) {
            nextState.canvas = canvas;
        }
        if (url) {
            nextState.imageUrl = '';
            nextState.loadingModel = false;
        }
        if (this.state.visibleModeList.indexOf(nextState.mode) >= 0) {
            callbackObj.showLookBtns = true;
        }

        if (Object.keys(nextState).length > 0) {
            this.setState(nextState);
        }
        if (Object.keys(callbackObj).length > 0) {
            Object.assign(callbackObj, nextState);
            this.sendToParentComponent(callbackObj);
        }
    };

    DiLiveTryOn.prototype.snap = function snap(lookObj, canvas, url) {
        var _this3 = this;

        var modeToSet = modes.confirmPhoto;
        if (url) {
            modeToSet = modes.modelCanvasShowing;
        }
        return this.state.engine.updateCanvasSize(canvas.width, canvas.height, canvas.ratio).then(function () {
            return _this3.state.engine.snap(lookObj.look, url);
        }).then(function () {
            return _this3.afterApply(url ? lookObj : false, canvas, modeToSet, _this3.state.mode, url);
        }).catch(function (err) {
            console.log(err);
            if (_this3.state.mode == modes.takingPhoto) {
                _this3.setState({ mode: modes.noFaceDetected });
            } else {
                _this3.setState({ mode: modes.modelCanvasShowing, loadingModel: false });
            }
        });
    };

    DiLiveTryOn.prototype.setLook = function setLook(lookObj, canvas, mode, setBefore, updateImage) {
        var _this4 = this;

        if (this.state.engine) {
            var defaultMode = [modes.canvasShowing, modes.photoCanvasShowing, modes.modelCanvasShowing, modes.takingPhoto, modes.confirmPhoto].indexOf(this.state.mode) >= 0 ? this.state.mode : modes.canvasShowing;
            defaultMode = this.state.mode == modes.menuShowing ? this.state.visibleMode : defaultMode;
            if (mode) {
                defaultMode = mode;
            }
            var modeToSet = [modes.confirmPhoto].indexOf(defaultMode) >= 0 ? modes.photoCanvasShowing : defaultMode;
            return this.state.engine.updateCanvasSize(canvas.width, canvas.height, canvas.ratio).then(function () {
                return _this4.state.engine.setLook(lookObj, defaultMode == modes.canvasShowing, defaultMode == modes.modelCanvasShowing, setBefore, updateImage);
            }).then(function () {
                return _this4.afterApply(lookObj, canvas, modeToSet, defaultMode);
            });
        } else {
            console.log('this.state.engine is null');
        }
    };

    DiLiveTryOn.prototype.getSkuInfoAndSetLook = function getSkuInfoAndSetLook(skus) {
        var _this5 = this;

        if (this.state.engineReady && this.state.visibleMode.indexOf(this.state.mode) >= 0) {

            var skusObj = validateSkus(skus, this.state.skuMap);
            return this.state.calibration.getLook(skusObj.skuArray).then(function (lookObj) {
                if (_this5.state.mode == 'modelCanvasShowing' && skusObj.skuArray.length == 0) {
                    lookObj.look = '';
                }
                return _this5.setLook(lookObj, _this5.state.canvas);
            }).then(function () {
                return _this5.setState({ skuMap: skusObj.skuMap });
            }).catch(function (error) {
                return console.error(error);
            });
        } else if (!this.state.engineReady) {
            var _skusObj = validateSkus(skus, this.state.skuMap);
            return this.state.calibration.getLook(_skusObj.skuArray).then(function (lookObj) {
                _this5.setState({ lookObj: lookObj, skuMap: _skusObj.skuMap });
            });
        }
    };

    DiLiveTryOn.prototype.skusAreEqual = function skusAreEqual(prevLookArr, currLookArr) {
        var prevLookString = Array.isArray(prevLookArr) ? prevLookArr.map(function (l) {
            return l.hex + "-" + l.region;
        }).sort().join() : "";
        var currLookString = Array.isArray(currLookArr) ? currLookArr.map(function (l) {
            return l.hex + "-" + l.region;
        }).sort().join() : "";
        return prevLookString == currLookString;
    };

    DiLiveTryOn.prototype.startStopEngine = function startStopEngine(startEngine) {
        var _this6 = this;

        var nextState = {};
        if (startEngine < 0) {
            nextState.playingRecordedVideo = false;
            nextState.setLookAfterUpdatingCanvas = false;
            nextState.playVideo = false;
            if (this.state.videoSrc) {
                this.state.engine.processFrames(false);
            }
        } else {
            nextState.setLookAfterUpdatingCanvas = true;
            if (this.state.videoSrc) {
                nextState.playingRecordedVideo = true;
                this.state.engine.processFrames(true);
                nextState.playVideo = false;
            } else {
                nextState.playingRecordedVideo = false;
                nextState.playVideo = true;
            }
        }
        this.setState(nextState, function () {
            _this6.sendToParentComponent(nextState);
        });
    };

    DiLiveTryOn.prototype.changeMode = function changeMode(modeObj) {
        var _this7 = this;

        var nextState = {};
        if (modeObj.value == 'liveVideo') {
            nextState.playingRecordedVideo = false;
            nextState.videoSrc = '';
            nextState.setLookAfterUpdatingCanvas = true;
            nextState.playVideo = true;
        } else if (modeObj.value == 'recordedVideo') {
            nextState.playingRecordedVideo = true;
            nextState.videoSrc = modeObj.url;
            nextState.setLookAfterUpdatingCanvas = true;
            nextState.playVideo = false;
        }
        this.setState(nextState, function () {
            _this7.sendToParentComponent(nextState);
        });
    };

    DiLiveTryOn.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
        var _this8 = this;

        if (this.state.engineReady && !this.skusAreEqual(prevProps.skus, this.props.skus)) {
            this.getSkuInfoAndSetLook(this.props.skus);
        } else if (!this.state.engineReady && !this.skusAreEqual(prevProps.skus, this.props.skus)) {
            var skusObj = validateSkus(this.props.skus, this.state.skuMap);
            return this.state.calibration.getLook(skusObj.skuArray).then(function (lookObj) {
                _this8.setState({ lookObj: lookObj, skuMap: skusObj.skuMap });
            });
        }

        if (this.state.engineReady && this.props.startEngine != prevProps.startEngine) {
            this.startStopEngine(this.props.startEngine);
        }

        if (prevProps.modeObj.value != this.props.modeObj.value || prevProps.modeObj.url != this.props.modeObj.url) {
            this.changeMode(this.props.modeObj);
        }

        if (!this.state.engineReady && !this.state.initializingEnging && this.state.ids && this.props.configs && this.state.canvas) {
            this.setState({ initializingEnging: true }, function () {
                _this8.sendToParentComponent({ initializingEnging: _this8.state.initializingEnging });
            });
            Engine.instance(this.diwebsdk, this.props.configs, this.props.pathToWorker, this.state.ids, this.state.canvas.width, this.state.canvas.height, this.state.canvas.ratio).then(function (engineInstance) {
                var _this9 = this;

                this.setState({ engineReady: true, engine: engineInstance }, function () {
                    //tofix gets called twice
                    _this9.sendToParentComponent({ engineReady: true, mode: _this9.state.mode });
                    if (_this9.state.visibleModeList.indexOf(_this9.state.mode) >= 0) {
                        _this9.sendToParentComponent({ showLookBtns: true, mode: _this9.state.mode });
                        _this9.setLook(_this9.state.lookObj, _this9.state.canvas);
                    }
                });
            }.bind(this));
        }
    };

    DiLiveTryOn.prototype.sendToParentComponent = function sendToParentComponent(obj) {
        typeof this.props.callback == "function" && this.props.callback(obj);
    };

    DiLiveTryOn.prototype.callbackFromComponent = function callbackFromComponent(action) {
        // { mode: modes.menuShowing }
        console.log(action);
        if (action) {
            var nextState = {};
            var callbackObj = {};

            if (action.button) {
                callbackObj.button = action.button;
            }

            if (action.canvas || action.videoIsReady) {
                if (!this.state.canvas || action.canvas && (action.canvas.width != this.state.canvas.width || action.canvas.height != this.state.canvas.height)) {
                    nextState.canvas = action.canvas;
                }
                if (this.state.setLookAfterUpdatingCanvas && action.videoIsReady) {
                    nextState.setLookAfterUpdatingCanvas = false;
                    if (this.state.mode != modes.canvasShowing) {
                        action.mode = modes.canvasShowing;
                    } else {
                        this.setLook(this.state.lookObj, nextState.canvas ? nextState.canvas : this.state.canvas, nextState.mode, action.setBefore, action.updateImage);
                    }
                }
            }
            if (action.viewer && action.viewer.height && action.viewer.height != this.state.menuHeight) {
                nextState.menuHeight = action.viewer.height;
                callbackObj.viewer = action.viewer;
            }
            if (action.ids) {
                if (!this.state.ids || action.ids.video != this.state.ids.video || action.ids.videoCanvas != this.state.ids.videoCanvas || action.ids.imageCanvas != this.state.ids.imageCanvas || action.ids.beforeCanvas != this.state.ids.beforeCanvas) {
                    nextState.ids = action.ids;
                }
            }

            if (action.mode && action.mode != this.state.mode) {
                nextState.mode = action.mode;
                callbackObj.mode = action.mode;

                if ([modes.canvasShowing, modes.photoCanvasShowing, modes.modelCanvasShowing, modes.imageLoaded].indexOf(nextState.mode) >= 0) {
                    if (nextState.mode == modes.imageLoaded) {
                        this.snap(this.state.skuMap.size > 0 ? this.state.lookObj : this.state.lookObjEmpty, nextState.canvas ? nextState.canvas : this.state.canvas, this.state.imageUrl);
                    } else {
                        var dimensions = this.DiViewer.updateCanvasSize(null, nextState.mode == modes.modelCanvasShowing);
                        if (dimensions && dimensions.canvas && dimensions.canvas.width != this.state.canvas.width && dimensions.canvas.height != this.state.canvas.height) {
                            nextState.canvas = dimensions.canvas;
                        }

                        this.setLook(this.state.lookObj, nextState.canvas ? nextState.canvas : this.state.canvas, nextState.mode, action.setBefore, action.updateImage);
                    }
                    nextState.mode = this.state.mode;
                    callbackObj.mode = this.state.mode;
                } else {
                    this.state.engineReady && this.state.engine.setVideoMode(false);
                }

                if (this.state.visibleModeList.indexOf(nextState.mode) >= 0 && this.state.engineReady) {
                    callbackObj.showLookBtns = true;
                } else {
                    callbackObj.showLookBtns = false;
                }
            }

            if (typeof action.imageUrl == 'string' && action.imageUrl != this.state.imageUrl) {
                // load image in diviewer
                nextState.imageUrl = action.imageUrl;
                nextState.loadingModel = true;
            }

            if (action.snap && action.snap != this.state.snap) {
                var _dimensions = this.DiViewer.updateCanvasSize();
                if (_dimensions && _dimensions.canvas && _dimensions.canvas.width != this.state.canvas.width && _dimensions.canvas.height != this.state.canvas.height) {
                    nextState.canvas = _dimensions.canvas;
                }
                this.snap({ look: this.state.calibration.softFocus }, nextState.canvas ? nextState.canvas : this.state.canvas);

                callbackObj.snap = action.snap;
            }

            if (action.clearAll && action.clearAll != this.state.clearAll) {
                nextState.clearAll = action.clearAll;
                nextState.lookObj = this.state.lookObjEmpty;
                callbackObj.clearAll = true;
                if (this.state.showingModeList.indexOf(this.state.mode) >= 0) {
                    this.setLook(nextState.lookObj, nextState.canvas ? nextState.canvas : this.state.canvas);
                }
            }

            if (action.click) {
                callbackObj.click = action.click;
            }
            if (typeof action.showMenuBar == 'boolean') {
                callbackObj.showMenuBar = action.showMenuBar;
            }
            if (typeof action.playingVideo == 'boolean') {
                callbackObj.playingVideo = action.playingVideo;
            }

            if (typeof action.cameraDenied == 'boolean') {
                nextState.cameraDenied = action.cameraDenied;
            }

            console.log(action, callbackObj, nextState, this.state.mode);

            if (Object.keys(callbackObj).length > 0) {
                Object.assign(callbackObj, nextState);
                this.sendToParentComponent(callbackObj);
            }

            if (Object.keys(nextState).length > 0) {
                this.setState(nextState);
            }
        }
    };

    DiLiveTryOn.prototype.render = function render() {
        var _this10 = this;

        return React.createElement(
            "div",
            { ref: function ref(c) {
                    return _this10.diwebsdk = c;
                },
                id: "diwebsdk" },
            React.createElement(
                "div",
                { id: "showmenuontopofviewer" },
                React.createElement(DiViewerMenu, {
                    mode: this.state.mode,
                    visibleMode: this.state.visibleMode,
                    cameraDenied: this.state.cameraDenied,
                    height: this.state.menuHeight,
                    bottomMenuHeight: this.props.bottomMenuHeight,
                    callback: this.callbackFromComponent,
                    mobile: this.props.mobile,
                    isDesktop: this.props.isDesktop,
                    selectedCategory: this.props.selectedCategory,
                    takePhotoTip: this.props.takePhotoTip,
                    selfieVerificationResult: this.props.selfieVerificationResult }),
                React.createElement(DiViewer, { ref: function ref(c) {
                        return _this10.DiViewer = c;
                    },
                    engineReady: this.state.engineReady,
                    mode: this.state.mode,
                    callback: this.callbackFromComponent,
                    resolution: this.state.resolution,
                    dimensionRatio: this.props.ratio,
                    playVideo: this.state.playVideo,
                    playingRecordedVideo: this.state.playingRecordedVideo,
                    videoSrc: this.state.videoSrc,
                    imageUrl: this.state.imageUrl,
                    bottomMenuHeight: this.props.bottomMenuHeight,
                    selectedCategory: this.props.selectedCategory }),
                React.createElement(Loader, { menuHeight: this.state.menuHeight,
                    engineReady: this.state.engineReady,
                    loadingModel: this.state.loadingModel,
                    loaderImage: this.state.loaderImage })
            ),
            React.createElement(
                "style",
                null,
                "\n#diwebsdk, #diwebsdk * {\n    box-sizing: content-box;\n  }\n\n#diwebsdk {\n    width: 100%;\n    font-size: 12px;\n    font-family: \"Helvetica,SF Pro Display\",\"Roboto\", Arial, san-serif;\n    position: relative;\n    border: 1px solid #979797;\n}\n\n@media (max-width: 992px) {\n    #diwebsdk {\n        border: none;\n    }\n}\n\n#showmenuontopofviewer {\n    position: relative;\n}\n\n.spinner{\n    width: 20%;\n    animation: 1s linear infinite spin;\n    position: absolute;\n    right: 30px;\n    top: 30px;\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n/*di-viewer-menu-bar*/\n\n\n.arrow.white g g{\n    fill: #ffffff;\n}\n.arrow.black g g{\n    fill: #303030;\n}\n.noFaceDetectedOverlay{\n    z-index: 9999;\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n    align-items: center;\n    background-color: rgba(48,48,48,0.78);\n}\n.noFaceDetectedOverlay .text {\n    color: #ffffff;\n    font-size: 20px;\n    margin: 0;\n}\n.noFaceDetectedOverlay .text.bold {\n    font-weight: bold;\n}\n.menuButtons {\n    z-index: 9999;\n    position: absolute;\n    bottom: 120px;\n    right: 5px;\n    display: flex;\n    flex-direction: row;\n}\n.bar {\n    z-index: 999;\n    padding: 17px;\n    display: flex;\n    margin: 0 0 20px 0;\n}\n.transparent {\n    position: absolute;\n    top: 0;\n    background-color: rgba(248,248,248,0.8);\n    width: calc(100% - 30px);\n}\n.orange {\n    background-color: #F47D39\n}\n.bar .center {\n    width: 60%;\n    justify-content: center;\n}\n.bar .parts {\n    display: flex;\n    align-items: center;\n}\n.bar .right {\n    justify-content: flex-end;\n    width: 20%;\n}\n.bar .left{\n    justify-content: flex-start;\n    width: 20%;\n}\n.bar .w50{\n    width: 50%;\n}\n.bar .w80 {\n    width: 80%;\n}\n.txt{\n    width: 100%;\n    align-items: flex-start;\n}\n.backArrow{\n    fill: rgb(255, 255, 255);\n    float: left;\n    cursor: pointer;\n}\n.headerwhite{\n    margin: 0;\n    padding: 0;\n    color: #ffffff;\n    font-size: 13px;\n    font-weight: bold;\n}\n\n\n/*di-viewer-menu*/\n\n#wrapper{\n    position: absolute;\n    top: 0;\n    width: 100%;\n    height: 500px;\n    z-index: 99;\n    \n    text-align: center;\n    overflow: hidden;\n}\n.useYourPhoto.wrapSection .divider{\n    background-color: #ffffff;\n    width: 20px;\n}\n.wrapSection .divider{\n    background-color: #E90B5A;\n    width: 2px;\n}\n.header{\n    color: #E90B5A;\n    font-weight: bold;\n    padding: 0px;\n    margin: auto 0 auto 0;\n    font-size: 14px;\n}\n\n.useYourPhoto .subheader, .useOurPhoto .subheader{\n    margin: 5px 0 auto 0;\n}\n.subheader{\n    padding: 0px;\n    margin: auto 0 auto 0;\n}\n.confirmPhoto {\n    height: inherit;\n    width: inherit;\n    display: flex;\n    flex-direction: column;\n}\n.menuBtns {\n    height: inherit;\n    width: inherit;\n    display: flex;\n    flex-direction: column;\n    /* justify-content: center; */\n    background-color: #ffffff;\n    overflow-y: overlay;\n    padding: 0 30px 0 0;\n}\n.btnsSection {\n    display: flex;\n    flex-direction: row;\n}\n.btnsSection.right {\n    margin-right: -5px;\n}\n.modelSection {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n}\n.wrapSection.modelSection {\n    justify-content: space-evenly;\n}\n\n.model {\n    width: 100px;\n    height: 100px;\n    background-repeat: no-repeat;\n    background-size: 68%;\n    background-position: top;\n    background-position-y: -14px;\n    margin: 0 0 15px 0;\n    cursor: pointer;\n    box-shadow: 0 0 4px 0px #D6DADF;\n}\n.model.lessMarg {\n    margin: 0 0 5px 0;\n}\n.model.thumb1 {\n    background-image: url(\"/innovation/glamlab/public/images/models/thumbs/ulta_model_01_iphone.jpeg\");\n}\n.model.thumb2 {\n    background-image: url(\"/innovation/glamlab/public/images/models/thumbs/ulta_model_02_iphone.jpeg\");\n}\n.model.thumb3 {\n    background-image: url(\"/innovation/glamlab/public/images/models/thumbs/ulta_model_03_iphone.jpeg\");\n    background-size: 72%;\n    background-position-y: -20px;\n}\n.model.thumb4 {\n    background-image: url(\"/innovation/glamlab/public/images/models/thumbs/ulta_model_04_iphone.jpeg\");\n}\n.model.thumb5 {\n    background-image: url(\"/innovation/glamlab/public/images/models/thumbs/ulta_model_05_iphone.jpeg\");\n}\n.model.thumb6 {\n    background-image: url(\"/innovation/glamlab/public/images/models/thumbs/ulta_model_06_iphone.jpeg\");\n}\n.model.thumb7 {\n    background-image: url(\"/innovation/glamlab/public/images/models/thumbs/ulta_model_07_iphone.jpeg\");\n}\n.model.thumb8 {\n    background-image: url(\"/innovation/glamlab/public/images/models/thumbs/ulta_model_08_iphone.jpeg\");\n}\n.model.thumb9 {\n    background-image: url(\"/innovation/glamlab/public/images/models/thumbs/ulta_model_09_iphone.jpeg\");\n}\n.model.thumb10 {\n    background-image: url(\"/innovation/glamlab/public/images/models/thumbs/ulta_model_10_iphone.jpeg\");\n}\n.model.thumb11 {\n    background-image: url(\"/innovation/glamlab/public/images/models/thumbs/ulta_model_11_iphone.jpeg\");\n}\n.model.thumb12 {\n    background-image: url(\"/innovation/glamlab/public/images/models/thumbs/ulta_model_12_iphone.jpeg\");\n}\n.model.thumb13 {\n    background-image: url(\"/innovation/glamlab/public/images/models/thumbs/ulta_model_13_iphone.jpeg\");\n}\n.model.thumb14 {\n    background-image: url(\"/innovation/glamlab/public/images/models/thumbs/ulta_model_14_iphone.jpeg\");\n}\n.model.thumb15 {\n    background-image: url(\"/innovation/glamlab/public/images/models/thumbs/ulta_model_15_iphone.jpeg\");\n}\n.wrapSection{\n    display: flex;\n    padding: 0 17px 20px 17px;\n    justify-content: space-between;\n    color: #636466d1;\n}\n.wrapSection.btnsWrap{\n    justify-content: center;\n}\n.useOurPhoto.cameraDenied{\n    flex-direction: column;\n    align-items: center;\n    padding-top: 40px;\n}\n.useOurPhoto.wrapSection, .useYourPhoto.wrapSection{\n    flex-direction: column;\n    align-items: center;\n    /* padding-top: 40px; */\n}\n.useOurPhoto.cameraDenied .header{\n    padding-bottom: 5px;\n}\n.wrapSection .right{\n    justify-content: flex-end;\n}\n.btns {\n    cursor: pointer;\n    background-color: #e6e6e6;\n    background-position: top;\n    background-size: 65px;\n    background-repeat: no-repeat;\n    color: #636466;\n    padding: 0px;\n    width: 103px;\n    height: 85px;\n    font-size: 11px;\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n}\n.live {\n    background-image: url('/innovation/glamlab/public/images/video.svg');\n    background-position-y: 16px;\n}\n.photo {\n    background-image: url('/innovation/glamlab/public/images/camera.svg');\n    background-position-y: 12px;\n    background-size: 60px;\n}\n\n.silhouette {\n    height: inherit;\n    background-image: url('/innovation/glamlab/public/images/silhouette.svg');\n    background-color: transparent;\n    background-repeat: no-repeat;\n    background-position: center 38%;\n    background-size: 200%;\n    position: relative;\n}\n.silhouette-green {\n    background-image: url('/innovation/glamlab/public/images/silhouette-green.svg') !important;\n}\n\n.silhouette-red {\n    background-image: url('/innovation/glamlab/public/images/silhouette-red.svg') !important;\n}\n\n.light-icon {\n    position: absolute;\n    right: 10px;\n    top: 65px;\n}\n.snapBtn {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    width: 100%;\n    height: 55px;\n    bottom: 0;\n    background-color: rgba(255,255,255, .35);\n}\n.circle {\n    position: absolute;\n    border-radius: 1000px;\n    cursor: pointer;\n    height: 50px;\n    width: 50px;\n    border: 4px solid #979797;\n    background-color: #FFFFFF;\n    box-shadow: 0 2px 16px 0 rgba(255,255,255,0.57);\n    margin: -20px 0 0 0;\n}\n\n\n/*di-viewer*/\n\n\n#diviewer {\n    margin: 0 auto;\n    padding: 0;\n    position : relative;\n    overflow: hidden;\n}\n\n/* canvas {\n    position: absolute;\n    top: 0;\n    left: 0;\n} */\n\n#videoCanvas {\n}\n#imageCanvas {\n}\n#modelCanvas {\n}\n#beforeCanvas {\n}\n.engineNotReady{\n    display: none;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    background-color: rgba(225, 225, 225, 0.5);\n    z-index: 999;\n}\n.abste {\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n#video {\n    margin: 0;\n    padding: 0;\n}\n.beforeAfterWrap{\n    height: inherit;\n    width: 100%;\n}\n.beforeWrapper{\n    height: inherit;\n    overflow: hidden;\n    left: 0;\n}\n.lineWrapper{\n    z-index: 999;\n    height: inherit;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n}\n.lineWrapper .line{\n    width: 1px;\n    height: inherit;\n    background-color: #ffffff;\n}\n\n/*di-icons*/\n\n.icon{\n    cursor: pointer;\n    margin: 0 3px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    font-size: 12px;\n    color: #303030;\n}\n.icon.small{\n    width: 25px;\n    margin: 0px 0 0 -6px;\n}\n.icon svg{\n    margin: 0 auto;\n    width: 32px;\n    height: 32px;\n    overflow: visible;\n}\n.icon.small svg{\n    width: 20px;\n    height: 20px;\n}\n.icon span.noicon{\n    font-size: 12px;\n}\n.icon span{\n    text-transform: capitalize;\n    padding: 6px 0 0 5px;\n}\n.btns span{\n    color: #636466;\n    padding: 6px 0 0 0;\n    font-size: 11px;\n}\n.btns svg{\n    width: 29px;\n    height: 29px;\n}\n.menuButtons svg {\n    width: 18px;\n    height: 18px;\n}\n.menuButtons .icon {\n    height: 49px;\n    width: 49px;\n    border-radius: 30px;\n    background-color: #FFFFFF;\n    box-shadow: 0 3px 21px 0 rgba(0,0,0,0.28);\n    justify-content: center;\n    margin: 0 5px;\n}\n.menuButtons .icon.remove svg{\n    width: 13px;\n    height: 13px;\n}\n.menuButtons .icon span {\n    padding: 2px 0 0 0;\n    font-size: 10px;\n}\n\n.icon.btn {\n    border: 1px solid #303030;\n    font-weight: bold;\n    border-radius: 5px;\n    padding: 3px 11px;\n    background: #fff;\n    min-width: 55px;\n    text-align: center;\n}\n.icon.btn.red{\n    background: #E90B5A;\n    border: 1px solid #E90B5A;\n    color: #fff;\n}\n\n.noFaceDetectedOverlay .icon.btn.red{\n    margin: 30px 0 0 0;\n}\n\n.icon.btn span{\n    padding: 0;\n    margin: 0 auto;\n}\n                    "
            )
        );
    };

    return DiLiveTryOn;
}(Component);

export { DiLiveTryOn as default };